module.exports = __webpack_public_path__ + "img/18.81a06708.jpg";